<template>
  <div class="scan-detail-container">
<!--    <header class="page-header">-->
<!--      <span class="page-title">扫码预警详情</span>-->
<!--      <button class="close-btn" @click="handleClose">×</button>-->
<!--    </header>-->

    <main class="content">
      <van-loading v-if="loading" class="loading-wrap" size="24px" vertical>
        加载中...
      </van-loading>

      <template v-else>
        <div
          v-for="item in warningList"
          :key="item.id"
          class="warning-card"
        >
          <div class="card-header">
            <div class="code-info">
              <span class="code-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
                  <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
                  <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
                  <rect x="14" y="14" width="3" height="3" rx="0.5" fill="currentColor"/>
                  <line x1="19" y1="14" x2="21" y2="14" stroke="currentColor" stroke-width="1.5"/>
                  <line x1="14" y1="19" x2="21" y2="19" stroke="currentColor" stroke-width="1.5"/>
                  <line x1="19" y1="14" x2="19" y2="21" stroke="currentColor" stroke-width="1.5"/>
                </svg>
              </span>
              <span class="code-text">{{ item.code }}</span>
            </div>
            <span class="risk-tag" v-if="item.riskLabel" :class="item.riskLevel">{{ item.riskLabel }}</span>
          </div>

          <div class="info-grid">
            <div class="info-row">
              <div class="info-item">
                <span class="label">物料编号:</span>
                <span class="value">{{ item.materialCode }}</span>
              </div>
              <div class="info-item">
                <span class="label">产品名称:</span>
                <span class="value">{{ item.productName }}</span>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <span class="label">扫码次数:</span>
                <span class="value highlight">{{ item.scanCount }} 次</span>
              </div>
              <div class="info-item">
                <span class="label">异常地区数:</span>
                <span class="value">{{ item.abnormalRegionCount }} 个</span>
              </div>
            </div>
          </div>

          <div class="region-tags">
            <span
              v-for="region in item.regions"
              :key="`${item.code}-${region}`"
              class="region-tag"
            >
              {{ region }}
            </span>
          </div>
        </div>

        <van-empty v-if="!warningList.length" description="暂无预警数据" />
      </template>
    </main>
  </div>
</template>

<script>
import apis from "@/apis/qrCode";

export default {
  name: "scanCodeDetail",
  data() {
    return {
      loading: false,
      warningList: [],
      idList: "",
      pushEmpNo: "",
    };
  },
  created() {
    this.parseQueryParams();
    this.getDetail();
  },
  mounted() {
    this.initRem();
    window.addEventListener("resize", this.initRem);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initRem);
  },
  methods: {
    parseQueryParams() {
      const { idList, pushEmpNo } = this.$route?.query || {};
      this.idList = idList || "";
      this.pushEmpNo = pushEmpNo || "";
    },
    getDetail() {
      this.loading = true;
      apis
        .scanGetDetail({
          idList: this.idList,
          pushEmpNo: this.pushEmpNo,
        })
        .then((res) => {
          if (res.code == 200) {
            this.warningList = this.formatWarningList(res.data || []);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatWarningList(list) {
      if (!Array.isArray(list)) return [];
      return list.map((item) => ({
        id: item.id,
        code: item.barcode,
        materialCode: item.proCode || "-",
        productName: item.proDesc || "-",
        scanCount: item.scanNum,
        abnormalRegionCount: item.errorAddrNum,
        regions: item.errorAddr
          ? item.errorAddr.split(";").filter(Boolean)
          : [],
        riskLevel: this.getRiskLevel(item.risk),
        riskLabel: this.getRiskLabel(item.risk),
      }));
    },
    getRiskLevel(risk) {
      const riskMap = {
        1: "high",
        2: "medium",
        3: "low",
      };
      return riskMap[risk] || "";
    },
    getRiskLabel(risk) {
      const riskMap = {
        1: "高风险",
        2: "中风险",
        3: "低风险",
      };
      return riskMap[risk] || "";
    },
    initRem() {
      const designWidth = 375;
      const rootFontSize = 110;
      const screenWidth = document.documentElement.clientWidth;
      const actualFontSize =
        (Math.min(screenWidth, 750) / designWidth) * rootFontSize;
      document.documentElement.style.fontSize = `${actualFontSize}px`;
    },
    handleClose() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        window.close();
      }
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.scan-detail-container {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 0.5rem;
  padding: 0 0.16rem;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.page-title {
  font-size: 0.16rem;
  font-weight: 500;
  color: #333;
}

.close-btn {
  width: 0.32rem;
  height: 0.32rem;
  border: none;
  background: transparent;
  font-size: 0.22rem;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:active {
    color: #666;
  }
}

.content {
  flex: 1;
  padding: 0.12rem 0.16rem;
  overflow-y: auto;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
}

.warning-card {
  background-color: #f5f7fa;
  border-radius: 0.08rem;
  padding: 0.14rem 0.12rem;
  margin-bottom: 0.12rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.12rem;
}

.code-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.code-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.06rem;
  color: #666;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
}

.code-text {
  font-size: 0.14rem;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.risk-tag {
  flex-shrink: 0;
  font-size: 0.12rem;
  padding: 0.02rem 0.08rem;
  border-radius: 0.04rem;
  margin-left: 0.08rem;

  &.high {
    color: #f56c6c;
    background-color: #fef0f0;
  }

  &.medium {
    color: #e6a23c;
    background-color: #fdf6ec;
  }

  &.low {
    color: #67c23a;
    background-color: #f0f9eb;
  }
}

.info-grid {
  margin-bottom: 0.1rem;
}

.info-row {
  display: flex;
  margin-bottom: 0.08rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.info-item {
  flex: 1;
  display: flex;
  align-items: flex-start;
  min-width: 0;
  font-size: 0.12rem;
  line-height: 0.18rem;

  .label {
    color: #999;
    flex-shrink: 0;
  }

  .value {
    color: #333;
    margin-left: 0.04rem;
    word-break: break-all;

    &.highlight {
      color: #f56c6c;
      font-weight: 500;
    }
  }
}

.region-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.06rem;
  margin-top: 0.1rem;
}

.region-tag {
  display: inline-block;
  padding: 0.04rem 0.1rem;
  font-size: 0.12rem;
  color: #666;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 0.04rem;
  line-height: 1.4;
}
</style>
